__turbopack_context__.v({
  "closeButton": "ContactForm-module__AGd1Rq__closeButton",
  "contactTitle": "ContactForm-module__AGd1Rq__contactTitle",
  "fadeIn": "ContactForm-module__AGd1Rq__fadeIn",
  "form": "ContactForm-module__AGd1Rq__form",
  "modal": "ContactForm-module__AGd1Rq__modal",
  "modalWrapper": "ContactForm-module__AGd1Rq__modalWrapper",
  "submitButton": "ContactForm-module__AGd1Rq__submitButton",
});
